const nexcess = {
  stylesheet: "default",
  iconColors: {
    default: "#ffffff",
    alpha: "#000000",
    beta: "#ffffff",
    gamma: "#004867",
    delta: "#ffffff",
    epsilon: "#0379ac",
    zeta: "#ffffff",
    eta: "#002434",
    theta: "#ffffff",
    iota: "#003f5a",
    kappa: "#767676",
    lambda: "#666666",
    mu: "#6bd0e8",
    nu: "#e7e7e7",
    xi: "#d4d3d8",
    omicron: "#d7eef7",
    pi: "#efefef",
    rho: "#f1fbff",
    sigma: "#00874f",
    tau: "#ab152d",
    upsilon: "#f9a400",
    phi: "#fffde6",
    chi: "#ffffff",
    psi: "#ffffff",
    omega: "#ffffff",
  },
};

const thermo = {
  stylesheet: "thermo",
  iconOverrides: {
    blue: "purple",
  },
  iconColors: {
    default: "#ffffff",
    alpha: "#000000",
    beta: "#ffffff",
    gamma: "#37024e",
    delta: "#a03600",
    epsilon: "#ce4600",
    zeta: "#37024e",
    eta: "#1d002a",
    theta: "#250433",
    iota: "#2b013d",
    kappa: "#767676",
    lambda: "#666666",
    mu: "#6bd0e8",
    nu: "#e7e7e7",
    xi: "#d4d3d8",
    omicron: "#d7def7",
    pi: "#efefef",
    rho: "#f1fbff",
    sigma: "#00874f",
    tau: "#ab152d",
    upsilon: "#f9a400",
    phi: "#fffde6",
    chi: "#cde2f6",
    psi: "#f1f1f1",
    omega: "#ffffff",
  },
};

const theme = {
  namespaced: true,
  state: {
    current: process.env.VUE_APP_THEME || "nexcess",
    list: {
      nexcess,
      thermo,
    },
    widget: process.env.VUE_APP_THEME_WIDGET,
  },
  mutations: {
    SET_THEME(state, payload) {
      state.current = payload;
    },
    TOGGLE_THEME_WIDGET(state) {
      state.widget = !state.widget;
    },
  },
  actions: {
    setTheme({ commit }, payload) {
      commit("SET_THEME", payload);
    },
    toggleWidget({ commit }) {
      commit("TOGGLE_THEME_WIDGET");
    },
  },
  getters: {
    getTheme: (state) => {
      return { ...state.list[state.current] };
    },
    getWidget: (state) => {
      return state.widget;
    },
  },
};

export default theme;
